import { FC, memo } from 'react';
import './spinner.scss';

const Spin: FC<{ section?: string }> = (props) => (
  <div className={`spinner-container ${props.section ? 'section' : ''}`}>
    <div className='spotify-loader'>
      <span className='spotify-loader__dot' />
      <span className='spotify-loader__dot' />
      <span className='spotify-loader__dot' />
    </div>
  </div>
);

export const Spinner: FC<{ loading: boolean; section?: string; children?: any }> = memo((props) => {
  const { loading, section, children } = props;
  return loading ? <Spin section={section} /> : children;
});

Spinner.displayName = 'Spinner';
